// The door: a plain script in the game page's <head> that runs before the
// page draws. A visitor who has never been here is sent to the introit (the
// game playing itself) first; after that, this browser comes straight to
// the game. A link into a rite or the map (a #hash) always goes straight in.

import { TEASER } from "../config/teaser.ts"
import { beenHere } from "../effects/storage.ts"

if (location.hash === "" && !beenHere()) location.replace(TEASER.path)
